import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class LayoutAPI {
    constructor() {
        this.baseUrl = new URL("bussched/layouts/", apiBusSchedBaseURL);
    }

    create(layout) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(layout)
        });
    }

    update(layoutId, layout) {
        return API.authenticatedRequest({
            url: new URL(layoutId, this.baseUrl),
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(layout)
        });
    }

    delete(layoutId) {
        return API.authenticatedRequest({
            url: new URL(layoutId, this.baseUrl),
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    list() {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/bussched/LayoutAPI.js